<dx-select-box
    #OriginCodeSelectBox
    [stylingMode]="dxMatStyle"
    [class.bds-mat-dense-form-field]="dense"
    [class.dx-mat-form-field-floatLabel-always]="matFloatLabel === 'always'"
    [dataSource]="originCodeSource"
    placeholder="Return Origin Code"
    itemTemplate="item"
    fieldTemplate="inputField"
    [valueExpr]="'originCode'"
    [searchExpr]="'originCode'"
    [showDropDownButton]="false"
    [openOnFieldClick]="false"
    [searchEnabled]="false"
    [value]="value"
    (onValueChanged)="onValueChange($event.value)"
>
    <dxi-button
        *ngIf="!value"
        name="addOriginCode"
        [options]="originCodeAddInlineButtonOptions"
    ></dxi-button>

    <div *dxTemplate="let data of 'inputField'">
        <dx-text-box
            style="display: inline-block"
            width="100%"
            [value]="originCodeDxSelectBoxDisplayExpr(data)"
            label="Origin Code"
        ></dx-text-box>
    </div>
</dx-select-box>
